import { FormActions } from '@app/components/form/FormActions';
import { Page } from '@app/components/page/Page';
import { useToast } from '@app/core/notifications';
import { pushTo } from '@app/core/routing';
import { useStation } from '@app/core/stations/hooks/useStation';
import { DailymotionPlatform } from '@app/modules/social-export/domain/platforms';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid, Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';

export function DailymotionApiKeyConnectPage() {
  const { station } = useParams<{ station: string }>();
  const stationId = station!;
  const stationData = useStation(stationId);
  const { $t } = useIntl();
  const { notifyError } = useToast();
  const mutation = socialExport.useConnectApiKeyDailymotionAuth();

  return (
    <Page>
      <Page.Header
        icon={DailymotionPlatform.Icon()}
        title={$t(
          {
            id: 'socialExport.dailymotion.connectTitle',
            defaultMessage: 'Conectar {stationName} con Dailymotion via API key',
          },
          { stationName: stationData.name },
        )}
      />
      <Page.Content>
        <FormContainer
          values={{
            key: '',
            secret: '',
            channelId: '',
          }}
          onSuccess={async (data) => {
            try {
              await mutation.mutateAsync({
                station: stationId as string,
                data,
              });
              pushTo('/admin/social-export/dailymotion');
            } catch (error: unknown) {
              notifyError((error as Error).message);
            }
          }}
          resolver={zodResolver(
            z.object({
              key: z.string().min(1),
              secret: z.string().min(1),
              channelId: z.string().min(7).max(7),
            }),
          )}
        >
          <Stack spacing={4} useFlexGap>
            <Grid container>
              <Grid item md={6}>
                <TextFieldElement
                  label={$t({
                    id: 'socialExport.dailymotion.apiKey',
                    defaultMessage: 'API key',
                  })}
                  name={'key'}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={6}>
                <TextFieldElement
                  label={$t({
                    id: 'socialExport.dailymotion.apiSecret',
                    defaultMessage: 'API secret',
                  })}
                  name={'secret'}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={3}>
                <TextFieldElement
                  label={$t({
                    id: 'socialExport.dailymotion.channelId',
                    defaultMessage: 'ID de canal',
                  })}
                  name={'channelId'}
                  required
                  fullWidth
                  helperText={$t({
                    id: 'socialExport.dailymotion.channelIdHelper',
                    defaultMessage: 'Identificador de 7 caracteres',
                  })}
                  inputProps={{
                    maxlength: 7,
                  }}
                />
              </Grid>
            </Grid>
            <FormActions />
          </Stack>
        </FormContainer>
      </Page.Content>
    </Page>
  );
}
